import * as ACTIONS from 'constant/actions/documentation'
import initialState from './initial-state'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.DOCUMENTATION_GET_LIST + '_PENDING':
      state = {
        ...state,
        loadingDocumentationList: true
      }
      break
    case ACTIONS.DOCUMENTATION_GET_LIST + '_FULFILLED':
      state = {
        ...state,
        loadingDocumentationList: false
      }
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshTree: false,
          loadingDocumentationList: false,
          documentationList: action.payload.data.documentationList
        }
      }
      break
    case ACTIONS.DOCUMENTATION_GET_PAGE_FROM_URL + '_PENDING':
      state = {
        ...state,
        loadingDocumentationPage: true
      }
      break
    case ACTIONS.DOCUMENTATION_GET_PAGE_FROM_URL + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: false,
        loadingDocumentationPage: false
      }
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshDocument: false,
          currentDocumentationPage: action.payload.data.documentation,
          showTreePanel: false
        }
      }
      break
    case ACTIONS.DOCUMENTATION_GET_PAGE + '_PENDING':
      state = {
        ...state,
        loadingDocumentationPage: true
      }
      break
    case ACTIONS.DOCUMENTATION_GET_PAGE + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshDocument: false,
          loadingDocumentationPage: false,
          currentDocumentationPage: action.payload.data.documentation,
          showTreePanel: false
        }
      }
      break
    case ACTIONS.DOCUMENTATION_GET_ATTACHMENT + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          attachments: {
            ...state.attachments,
            [action.payload.data.attachment.DAMN]: action.payload.data.attachment
          }
        }
      }
      break
    case ACTIONS.DOCUMENTATION_SHOW_MODAL:
      state = {
        ...state,
        modalContent: action.modalContent,
        modalShowing: true
      }
      break
    case ACTIONS.DOCUMENTATION_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case ACTIONS.DOCUMENTATION_EDIT_DOCUMENT + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: true,
        refreshTree: true
      }
      break
    case ACTIONS.DOCUMENTATION_ADD_GROUP + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: true,
        refreshTree: true
      }
      break
    case ACTIONS.DOCUMENTATION_DELETE_GROUP + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: true,
        refreshTree: true
      }
      break
    case ACTIONS.DOCUMENTATION_ADD_DOCUMENT + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: true,
        refreshTree: true,
        newNode: action.payload.data.node,
      }
      break
    case ACTIONS.DOCUMENTATION_DELETE_DOCUMENT + '_FULFILLED':
      state = {
        ...state,
        refreshDocument: true,
        refreshTree: true
      }
      break
    case ACTIONS.DOCUMENTATION_UPDATE_CONTENT + '_FULFILLED':

      state = {
        ...state,
        refreshDocument: true
      }
      break
    case ACTIONS.DOCUMENTATION_UPLOAD_ATTACHMENT + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          documentationAttachment: action.payload.data.damn
        }
      }
      break
    case ACTIONS.DOCUMENTATION_EDIT_DOCUMENT_DETAILS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
        refreshDocument: true
        }
      }
      break
    case ACTIONS.DOCUMENTATION_SET_SHOW_TREE_PANEL:
      state = {
        ...state,
        showTreePanel: action.showing
      }
  }
  return state
}
